import Hero from './headfoot/Hero'
import Footer from './headfoot/Footer'
// import Feature from './Feature'

export default function Home() {
  return (
    <>
      <Hero />
      {/* <Feature /> */}
      <Footer />
    </>
  )
}
